import { render, staticRenderFns } from "./insuranceDetail.vue?vue&type=template&id=ba692722&scoped=true"
import script from "./insuranceDetail.vue?vue&type=script&lang=js"
export * from "./insuranceDetail.vue?vue&type=script&lang=js"
import style0 from "./insuranceDetail.vue?vue&type=style&index=0&id=ba692722&prod&lang=less&scoped=true"
import style1 from "./insuranceDetail.vue?vue&type=style&index=1&id=ba692722&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba692722",
  null
  
)

export default component.exports